import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="page-x pt-32 pb-32 min-h-[70vh] flex flex-col items-center justify-center text-center" data-testid="notfound-page">
      <Helmet><title>404 — vdesigns.eps</title></Helmet>
      <p className="mono" style={{ color: "var(--blue)" }}>ERROR · FILE NOT FOUND</p>
      <h1 className="display" style={{ fontSize: "clamp(72px,18vw,260px)", color: "var(--ink)" }}>404</h1>
      <p className="lead mt-4" style={{ color: "var(--grey)" }}>This file isn't in the archive.</p>
      <Link to="/work" className="btn btn--ink mt-8">Back to all work →</Link>
    </div>
  );
}
